import { Link } from "react-router-dom";
import { Info, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { PRICING } from "@/data/content";

const Column = ({ title, rows, highlight }) => (
  <div
    data-testid={`pricing-${title.toLowerCase()}`}
    className={`relative flex flex-col rounded-3xl border p-7 transition-all ${
      highlight
        ? "border-emerald-700 bg-emerald-700 text-white shadow-2xl shadow-emerald-700/25 lg:-translate-y-3"
        : "border-slate-200 bg-white text-slate-900 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
    }`}
  >
    {highlight && (
      <span className="absolute -top-3 left-7 rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-emerald-700">
        Most requested
      </span>
    )}
    <h3 className={`font-display text-2xl font-bold ${highlight ? "text-white" : "text-slate-900"}`}>{title}</h3>
    <ul className="mt-6 space-y-3">
      {rows.map((r) => (
        <li key={r.label} className={`flex items-center justify-between gap-4 border-b pb-3 text-sm ${highlight ? "border-white/20" : "border-slate-100"}`}>
          <span className={highlight ? "text-emerald-50" : "text-slate-600"}>{r.label}</span>
          <span className={`shrink-0 font-bold ${r.price.startsWith("€") ? "" : "text-xs font-semibold"} ${highlight ? "text-white" : "text-emerald-700"}`}>
            {r.price.startsWith("€") ? `From ${r.price}` : r.price}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export const Pricing = () => (
  <section id="prices" className="bg-slate-50 py-20 sm:py-28" data-testid="pricing-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-widest text-emerald-700">Transparent pricing</p>
        <h2 className="mt-3 font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          End of Tenancy Cleaning Prices
        </h2>
        <div className="mt-5 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 sm:max-w-3xl">
          <Info size={18} className="mt-0.5 shrink-0" />
          <p>
            <strong>All prices are starting prices.</strong> The final quote depends on the size,
            condition and cleaning requirements of the property. Please send photos or a short video
            before booking.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <Reveal delay={0.05}><Column title="Apartments" rows={PRICING.apartments} /></Reveal>
        <Reveal delay={0.12}><Column title="Houses" rows={PRICING.houses} highlight /></Reveal>
        <Reveal delay={0.19}><Column title="Extras" rows={PRICING.extras} /></Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 flex justify-center">
          <Link
            to="/contact" data-testid="pricing-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-emerald-700 px-8 py-4 text-base font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-emerald-800 hover:shadow-xl hover:shadow-emerald-700/25"
          >
            Send Photos for an Exact Quote
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
